import { AccountInfo, LogLevel } from '@azure/msal-browser';

const clientId: string = process.env.REACT_APP_AZURE_AD_CLIENT_ID ?? '';
const apiClientId: string = process.env.REACT_APP_AZURE_AD_API_CLIENT_ID ?? '';
const instance: string = process.env.REACT_APP_AZURE_AD_INSTANCE ?? '';
const tenant: string = process.env.REACT_APP_AZURE_AD_TENANT ?? '';
const tenantId: string = process.env.REACT_APP_AZURE_AD_TENANT_ID ?? '';
const apiScopeName: string =
  process.env.REACT_APP_AZURE_AD_API_SCOPE_NAME ?? '';
const appUri: string = process.env.REACT_APP_URI ?? '';
export const appBaseName: string = process.env.REACT_APP_BASENAME ?? '';
export const stPortalUrl: string = process.env.REACT_APP_ST_PORTAL_URL ?? '';
const employeeSignInPolicy = 'b2c_1a_b2e_signin';
export const signInPolicy = 'B2C_1A_FA_EIDv2_Signin';
export const wellsFargoSignInPolicy = 'B2C_1A_FA_PN_WELLS_DT_Signupsignin';
export const forgotUsernamePolicy = 'B2C_1A_FA_EIDv2_ForgotUsername';
export const forgotPasswordPolicy = 'B2C_1A_FA_EIDv2_ForgotPassword';
export const profileViewPolicy = 'B2C_1A_FA_EIDv2_ProfileView';
export const profileEditPolicy = 'B2C_1A_FA_EIDv2_ProfileEdit';
export const editAuthenticationPhonePolicy = 'B2C_1A_FA_EIDv2_PhoneEdit';
export const editEmailPolicy = 'B2C_1A_FA_EIDv2_EmailEdit';
export const resetPasswordPolicy = 'B2C_1A_FA_EIDv2_ResetPassword';
export const onDemandMFAPhonePolicy = 'B2C_1A_FA_EIDv2_MFAPhone';
const baseAuthority = `${instance}/${tenantId}`;
export const employeeSignInAuthority = `${baseAuthority}/${employeeSignInPolicy}`;
export const signInAuthority = `${baseAuthority}/${signInPolicy}`;
export const wellsFargoSignInAuthority = `${baseAuthority}/${wellsFargoSignInPolicy}`;
const forgotUsernameAuthority = `${baseAuthority}/${forgotUsernamePolicy}`;
const forgotPasswordAuthority = `${baseAuthority}/${forgotPasswordPolicy}`;
const profileViewAuthority = `${baseAuthority}/${profileViewPolicy}`;
const profileEditAuthority = `${baseAuthority}/${profileEditPolicy}`;
const resetPasswordAuthority = `${baseAuthority}/${resetPasswordPolicy}`;
const editAuthenticationPhoneAuthority = `${baseAuthority}/${editAuthenticationPhonePolicy}`;
const editEmailAuthority = `${baseAuthority}/${editEmailPolicy}`;
const baseUrl = `${appUri}/${appBaseName}`;
const baseRelativeUrl = `/${appBaseName}`;
export const relativeForgotUsernameUrl = `${baseRelativeUrl}/public/forgot-username`;
export const relativeForgotPasswordUrl = `${baseRelativeUrl}/public/forgot-password`;
export const relativeProfileViewUrl = `${baseRelativeUrl}/public/profile-view`;
export const relativeProfileEditUrl = `${baseRelativeUrl}/public/edit-profile`;
export const relativeEditAuthenticationPhoneUrl = `${baseRelativeUrl}/public/edit-authentication-phone`;
export const relativeEditEmailPhoneUrl = `${baseRelativeUrl}/public/edit-email`;
export const relativeResetPasswordUrl = `${baseRelativeUrl}/public/update-password`;
export const relativeOnDemandMFAPhoneUrl = `${baseRelativeUrl}/public/on-demand-mfa-phone`;
const loginUrl = `${baseUrl}/public/login`;
const accessTokenRequestUserScope = `https://${tenant}/${apiClientId}/${apiScopeName}`;

export const msalConfig = {
  auth: {
    clientId: clientId,
    authority: employeeSignInAuthority,
    knownAuthorities: [instance, tenant],
    redirectUri: baseUrl,
    postLogoutRedirectUri: loginUrl,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: true,
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  authority: signInAuthority,
  scopes: [],
};

export const employeeLoginRequest = {
  authority: employeeSignInAuthority,
  scopes: [],
};

export const wellsFargoLoginRequest = {
  authority: wellsFargoSignInAuthority,
  scopes: [],
};

export const forgotUsernameRequest = {
  authority: forgotUsernameAuthority,
  scopes: [],
};

export const forgotPasswordRequest = {
  authority: forgotPasswordAuthority,
  scopes: [],
};

export const profileViewRequest = {
  authority: profileViewAuthority,
  scopes: [],
};

export const editEmailRequest = {
  authority: editEmailAuthority,
  scopes: [],
};

export const profileEditRequest = {
  authority: profileEditAuthority,
  scopes: [],
};

export const resetPasswordRequest = {
  authority: resetPasswordAuthority,
  scopes: [],
};

export const editAuthenticationPhoneRequest = {
  authority: editAuthenticationPhoneAuthority,
  scopes: [],
};

export const getApiAccessRequestSilent = (
  account: AccountInfo | null,
  authority: string,
) => {
  return {
    scopes: [accessTokenRequestUserScope],
    account: account ?? undefined,
    authority: authority,
  };
};

export const getApiAccessRequest = (authority: string) => {
  return {
    scopes: [accessTokenRequestUserScope],
    authority: authority,
  };
};
